import { Card, CardContent, CardHeader, Divider, Grid, Typography } from "@material-ui/core";
import React, { useContext } from "react";
import { useNavigate } from "../../../hooks/useNavigate";
import { HistoryContext } from "../../../redux/historyContext";
import CaseRow from "../../dashboard/CaseRow";
import { userRendererStyles } from "./useRendererStyles";
export const CaseListTile = ({ tile, navigate }) => {
    const classes = userRendererStyles();
    const { location } = useContext(HistoryContext);
    const caseNavigate = useNavigate(location);
    const navigateToCase = (id) => caseNavigate(`/complaints/${id}/activity`);
    return (React.createElement(Grid, { item: true, xs: 12, md: 12 },
        React.createElement(Card, { className: classes.root },
            React.createElement(CardHeader, { title: React.createElement(Typography, { variant: "body1", className: classes.cardHeading }, tile.title), className: classes.header, style: { paddingBottom: 15, paddingTop: 15 } }),
            React.createElement(Divider, null),
            React.createElement(CardContent, null, tile.parsedData.map(element => {
                return (React.createElement(CaseRow, { key: element.id, element: element, onNavigate: navigateToCase }));
            })))));
};
